import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<'videoCount', MessageDescriptor> = defineMessages({
	videoCount: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-loom-entity.videoCount',
		defaultMessage: '{count, plural, one {# video} other {# videos}}',
		description: 'Number of videos associated with a native Loom tag or folder search result.',
	},
});
